import { useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import Button from "../../../../common/Button"
import { uploadProcodocsDocumentApi } from "../../../../../lib/fetchApi"
import { notificationActions } from "../../../../../store/notifications"
import { caseActions } from "../../../../../store/case"
import { rejectOversizedBoxUploadFiles } from "../../../../../lib/docs"

export default function FileUploadButton({practiceId, documentTypeId, caseAttorneyId, usedFor, activeCase, btnRed, compact, missingDocumentTypeUploadErrorMessage}) {
    const inputRef = useRef(null)
    const dispatch = useDispatch()

    const [loading, setLoading] = useState(false)

    const userToken = useSelector(state => state.user.token)

    const onFileDrop = (e) => {
        if (e.target.files.length > 0) {
            if (missingDocumentTypeUploadErrorMessage && (documentTypeId == null || documentTypeId === '')) {
                dispatch(notificationActions.setError({
                    errorMessage: missingDocumentTypeUploadErrorMessage
                }))
                e.target.value = ''
                return
            }
            const { accepted, rejectedMessage } = rejectOversizedBoxUploadFiles(e.target.files)
            if (rejectedMessage) {
                dispatch(notificationActions.setError({ errorMessage: rejectedMessage }))
            }
            if (accepted.length === 0) {
                e.target.value = ''
                return
            }
            let filesArray = accepted.map(item => {                
                return {
                    id: Math.random(),
                    file: item.name,
                    file_to_upload: item,
                    practices: null,
                    procodocs_document_type_id: null,
                    notes: null
                }
            })


            if(filesArray && filesArray.length) {
                let file = filesArray[0]
                let formData = new FormData();

                formData.append("file", file.file_to_upload);
                formData.append("notes", null);
                formData.append("procodocs_document_type_id", documentTypeId)
                formData.append("practices", practiceId)
                formData.append("case_attorney_id", caseAttorneyId)
                formData.append("for_case_attorney", 1)

                if (usedFor == 'HIPAA' || usedFor == 'LOR' || usedFor == 'LOP') {
                    formData.append("is_ecm_locked", 0)
                }

                let reqBody = formData
                saveFileHandler(reqBody)
            }
        }

	}

    async function saveFileHandler(req) {
        setLoading(true)
        const upload = await uploadProcodocsDocumentApi(userToken, activeCase.case.id, req, dispatch)

        if (upload && upload.errorMessage) {
            dispatch(notificationActions.setError(upload))
        } else {
            // /success 
            dispatch(caseActions.pushItemToProcoDocuments(upload))
        }

         setLoading(false)
    }  

    const openUploadHandler = () => {
        inputRef.current.click()
    }

    const btnStyle = compact
        ? (btnRed ? 'btn_small_icon_red' : 'btn_small_icon')
        : (btnRed ? 'document_upload_red' : 'document_upload')

    return <>
        <input ref={inputRef} type="file" value="" onChange={onFileDrop} name="upload_number_1" id="upload_number_1" style={{display: 'none'}}/>
        <Button click={openUploadHandler} isLoading={loading} btnStyle={btnStyle}><i className="ti ti-upload" ></i></Button>
    </>
}